import { Component, OnInit } from '@angular/core';
import { FileService } from '@app/core/services/file.service';
import { ApiService, JwtService } from '@app/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.css']
})
export class StatementsComponent implements OnInit {
  constructor(private fileService: FileService,
    private apiService: ApiService,
    private jwtService: JwtService,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }
  //currentParticipantID: String;
  ngOnInit() {
    this.spinnerService.show();
   // this.currentParticipantID = this.jwtService.getParticipantId();
    this.getStatementLink();
  }

  StatementList = [];
  getStatementLink() {
    // const params = { "participantId": this.currentParticipantID };
    // return this.apiService.get("/statements/" + this.currentParticipantID).subscribe(
         return this.apiService.get("/statements").subscribe(
      data => {
        this.StatementList = data.data.links;
        this.spinnerService.hide();
      },
      error => {
        this.spinnerService.hide();
      }
    );
  }
  download(path: string) {
    this.fileService.downloadPDF(path).subscribe(
      data => this.openFile(data)
    );
  }
  openFile(data: Response) {
    var blob = new Blob([data], { type: 'application/pdf' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
    }
    else {
      var objectUrl = window.URL.createObjectURL(blob);
      if (navigator.userAgent.indexOf("Chrome") != -1 || navigator.userAgent.indexOf("Firefox") != -1) {
        window.open(objectUrl);
      } else { //Safari & Opera iOS
        window.location.href = objectUrl;
      }
    }
  }
}
